export const iterator = (num: number) => Array.from({ length: num }, (_, index) => index);
